







































































































































































































































































































































import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { AgreementForm } from '../types/AgreementForm'
import Datepicker from "vue2-datepicker"
import moment from 'moment'
import { Option } from '../types/Option'
import { Agreement } from '../types/Agreement'
import { cloneDeep } from 'lodash'
import { formatNumber } from '../utils'

interface PlanSchedule {
    id: number | null
    idContract: number
    datePayment: number,
    sumPayment: number | null
    dateBeg: number | null
    dateEnd: number | null
    dayCount: number | null
    sumBase: number | null
    typeSchedule: number
    userName: string | null
    updateDate: number | null
}

interface PlanRow {
    id: number | null
    idContract: number
    datePayment: Date,

    sumPayment: number | null
    sumPaymentPrincipal: number | null
    sumPaymentInterest: number | null
    leftPrincipal: number

    dateBeg: Date | null
    dateEnd: Date | null
    dayCount: number | null
    sumBase: number | null
    typeSchedule: number
    userName: string | null
    updateDate: number | null
}

interface TableField {
    key: string
    label: string
    variant?: string
}

@Component({
    name: 'plan-schedule-tab',
    components: {
        'date-picker': Datepicker
    }
})
export default class PlanScheduleTab extends Vue {
    // #region Props
    @Prop({
        type: Number,
        required: true
    })
    public readonly agreementId!: number

    @Prop({
        type: Function,
        required: true
    })
    public readonly changeModeFromAddToReadOnly!: () => void

    @Prop({
        type: Object,
        required: true
    })
    public readonly mainAgreementForm!: AgreementForm

    @Prop({
        type: Object,
        required: true
    })
    public readonly form!: AgreementForm

    @Prop({
        type: String,
        required: true
    })
    public readonly currentMode!: string // TODO: define type

    @Prop({
        type: Boolean,
        required: true
    })
    public readonly isWriteAccess!: boolean
    // #endregion

    // #region Data
    private frequencyOptions: Option<string>[] = []
    private agreement: Agreement | null = null
    private previousAgreement: Agreement | null = null
    private allAgreements: Agreement[] | null = null
    private frequency: Option<string> | null = null
    private frequencyRate: Option<string> | null = null
    private frequencyIncome: Option<string> | null = null
    public firstInterestDate: Date | null = null
    public otherDatesMonth: number | null = null
    public otherDatesDay: number | null = null
    public firstInflowDate: Date | null = null
    public firstPrincipalDate: Date | null = null
    private totalSum = 0
    private totalPrincipalSum = 0
    private progress = 0
    public editMode = false
    public editInterest = false
    public scheduleData: PlanRow[] = []

    private tempScheduleData: PlanRow[] = []
    private tempFrequency: Option<string> | null = null
    private tempFrequencyRate: Option<string> | null = null
    private tempFrequencyIncome: Option<string> | null = null
    private tempFirstInflowDate: Date | null = null
    private tempFirstPrincipalDate: Date | null = null
    private tempFirstInterestDate: Date | null = null
    private tempOtherDatesMonth: number | null = null
    private tempOtherDatesDay: number | null = null

    public tableFields: TableField[] = [
        {
            key: "rowNumber",
            label: "№",
        },
        {
            key: "leftPrincipal",
            label: "Остаток основного долга на начало периода",
        },
        {
            key: "year",
            label: "Год",
        },
        {
            key: "datePayment",
            label: "Дата платежа",
        },
        {
            key: "sumPayment",
            label: "Сумма поступления",
        },
        {
            key: "sumPaymentPrincipal",
            label: "Сумма погашения основного долга",
        },
        {
            key: "dateBeg",
            label: "Начало периода начисления",
        },
        {
            key: "dateEnd",
            label: "Окончание периода начисления",
        },
        {
            key: "dayCount",
            label: "Кол-во дней",
        },
        {
            key: "sumBase",
            label: "Базовая сумма для начисления вознаграждения",
        },
        {
            key: "sumPaymentInterest",
            label: "Сумма начисленного вознаграждения",
        },
        {
            key: "action",
            label: "",
        },
    ]
    private previousTableFields: TableField[] = [] 
    // #endregion

    // #region Getters
    get warning(): 'warning' | '' {
        return !this.doesAmountAlign ? 'warning' : ''
    }

    get doesAmountAlign(): boolean {
        return this.agreement?.amount === this.totalSum
    }
    // #endregion

    // #region LifeCycle
    private async created() {
        await this.setFrequencyOptions()
        this.agreement = await this.getAgreement(this.agreementId)
        this.progress = 30
        this.allAgreements = await this.getAgreements(this.agreementId)
        this.progress = 50
        this.scheduleData = await this.loadScheduleData(this.agreementId)
        await this.setUpPreviousAgreementSchedule()
        this.setFrequenciesIfPresent(this.agreement!)
        this.setInterestDateIfPresent(this.agreement!)
        this.setDatesIfPresent()
        this.emitSetPlan()
        this.progress = 100
    }
    // #endregion

    // #region Methods
    emitSetPlan() {
        this.$emit('setPlan', {
            inflowFrequency: this.frequencyIncome?.label ?? '',
            principalFrequency: this.frequency?.label ?? '',
            interestFrequency: this.frequencyRate?.label ?? '',
            initialInflowDate: this.firstInflowDate ? moment(this.firstInflowDate).format('YYYY-MM-DD') : null,
            initialPrincipalDate: this.firstPrincipalDate ? moment(this.firstPrincipalDate).format('YYYY-MM-DD') : null,
            initialInterestDate: this.firstInterestDate ? moment(this.firstInterestDate).format('YYYY-MM-DD') : null,
            followingInterestDay: this.otherDatesDay,
            followingInterestMonth: this.otherDatesMonth,
            rows: cloneDeep(this.scheduleData)
        })
    }

    private async setFrequencyOptions() {
        const response = await fetch('/api/stat-dict/report-frequency/parentless')
        if (!response.ok) {
            this.makeToast('Не удалось загрузить варианты перодичностей', 'Сообщение', 'danger')
        }

        const data = await response.json()
        const options: Option<string>[]  = data
            .filter((it: any) => ['001', '002', '003', '004'].includes(it.code))
            .map((it: any) => {
                const temp: Option<string> = {
                    value: it.code,
                    label: `${it.code} - ${it.name_ru}`
                } 
                return temp
            }) 

        this.frequencyOptions = options
    }

    private async getAgreement(id: number): Promise<Agreement> {
        const response = await fetch(`/api/budget-loan/${id}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить договор (план)', 'Сообщение', 'danger')
            throw new Error('')
        }
        const agreement: Agreement = await response.json()
        return agreement
    }

    private async getAgreements(id: number): Promise<Agreement[]> {
        const response = await fetch(`/api/budget-loan/${id}/with-additionals`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить договора (план)', 'Сообщение', 'danger')
            throw new Error('')
        }

        const agreements: Agreement[] = await response.json()
        return agreements
    }

    private setFrequenciesIfPresent(agreement: Agreement) {
        const agreementCopy = cloneDeep(agreement)

        const frequency = this.frequencyOptions.find(it => it.value === agreementCopy.frequency) ?? null
        this.frequency = cloneDeep(frequency)

        const frequencyRate = this.frequencyOptions.find(it => it.value === agreementCopy.frequencyRate) ?? null
        this.frequencyRate = cloneDeep(frequencyRate)

        const frequencyIncome = this.frequencyOptions.find(it => it.value === agreementCopy.frequencyIncome) ?? null
        this.frequencyIncome = cloneDeep(frequencyIncome)
    }

    private setInterestDateIfPresent(agreement: Agreement) {
        this.firstInterestDate = agreement.initialInterestRepaymentDate ? new Date(agreement.initialInterestRepaymentDate) : null 
        this.otherDatesMonth = agreement.followingInterestRepaymentMonth
        this.otherDatesDay = agreement.followingInterestRepaymentDay
    }

    private setDatesIfPresent() {
        const firstIncome = this.scheduleData.find(item => item.sumPayment)
        if (firstIncome) {
            this.firstInflowDate = new Date(firstIncome.datePayment)
        }

        const firstRepayment = this.scheduleData.find(item => item.sumPaymentPrincipal)
        if (firstRepayment) {
            this.firstPrincipalDate = new Date(firstRepayment.datePayment)
        }
    }

    private async loadScheduleData(agreementId: number) {
        const plans: PlanSchedule[] = await this.fetchPaymentSchedule(agreementId)

        const unsortedScheduleData = plans

        // (1/3) fetching inflow
        const inflowItems: PlanRow[] = unsortedScheduleData
            .filter(item => item.typeSchedule === 1)
            .map(it => {
                const temp: PlanRow = {
                    id: it.id,
                    idContract: it.idContract,
                    datePayment: new Date(it.datePayment),
                    sumPayment: it.sumPayment,
                    sumPaymentPrincipal: null,
                    sumPaymentInterest: null,
                    leftPrincipal: 0,
                    dateBeg: it.dateBeg ? new Date(it.dateBeg) : null,
                    dateEnd: it.dateEnd ? new Date(it.dateEnd) : null,
                    dayCount: it.dayCount,
                    sumBase: it.sumBase,
                    typeSchedule: it.typeSchedule,
                    userName: it.userName,
                    updateDate: it.updateDate
                }
                return temp
            })

        this.progress = 30

        // (2/3) fetching principal repayment
        const principalItems: PlanRow[] = unsortedScheduleData
            .filter(item => item.typeSchedule === 2)
            .map(it => {
                const temp: PlanRow = {
                    id: it.id,
                    idContract: it.idContract,
                    datePayment: new Date(it.datePayment),
                    sumPayment: 0,
                    sumPaymentPrincipal: it.sumPayment,
                    sumPaymentInterest: null,
                    leftPrincipal: 0,
                    dateBeg: it.dateBeg ? new Date(it.dateBeg) : null,
                    dateEnd: it.dateEnd ? new Date(it.dateEnd) : null,
                    dayCount: it.dayCount,
                    sumBase: it.sumBase,
                    typeSchedule: it.typeSchedule,
                    userName: it.userName,
                    updateDate: it.updateDate
                }
                return temp
            })

        this.progress = 60
        
        // (3/3) fetching interest
        const interestItems = unsortedScheduleData
            .filter(item => item.typeSchedule === 3)
            .map(it => {
                const temp: PlanRow = {
                    id: it.id,
                    idContract: it.idContract,
                    datePayment: new Date(it.datePayment),
                    sumPayment: null,
                    sumPaymentPrincipal: null,
                    sumPaymentInterest: it.sumPayment,
                    leftPrincipal: 0,
                    dateBeg: it.dateBeg ? new Date(it.dateBeg) : null,
                    dateEnd: it.dateEnd ? new Date(it.dateEnd) : null,
                    dayCount: it.dayCount,
                    sumBase: it.sumBase,
                    typeSchedule: it.typeSchedule,
                    userName: it.userName,
                    updateDate: it.updateDate
                }
                return temp
            })

        this.progress = 90

        // combining all graphs
        let combinedItems = inflowItems
        const toAddPrincipalItems = []
        for (let i = 0; i < principalItems.length; i++) {
            const principalItem = principalItems[i]

            const sameDateItem = combinedItems.find(inflowItem => inflowItem.datePayment === principalItem.datePayment)
            if (sameDateItem) {
                sameDateItem.sumPaymentPrincipal = principalItem.sumPaymentPrincipal
            } else {
                toAddPrincipalItems.push(principalItem)
            }
        }
        combinedItems = combinedItems.concat(toAddPrincipalItems)

        const toAddInterestItems = []
        for (let i = 0; i < interestItems.length; i++) {
            const interestItem = interestItems[i]
            const sameDateItem = combinedItems.find(combinedItem => this.toYYYYMMDD(combinedItem.datePayment) === this.toYYYYMMDD(interestItem.datePayment))
            if (sameDateItem) {
                sameDateItem.sumPaymentInterest = interestItem.sumPaymentInterest
                sameDateItem.dateBeg = interestItem.dateBeg
                sameDateItem.dateEnd = interestItem.dateEnd
                sameDateItem.dayCount = interestItem.dayCount
                sameDateItem.sumBase = interestItem.sumBase
            } else {
                toAddInterestItems.push(interestItem)
            }
        }
        combinedItems = combinedItems.concat(toAddInterestItems)

        combinedItems.forEach((item, index) => {
            // set zeros in upsent payments
            if (!item.sumPayment) {
                item.sumPayment = 0
            }
            if (!item.sumPaymentPrincipal) {
                item.sumPaymentPrincipal = 0
            }
            if (!item.sumPaymentInterest) {
                item.sumPaymentInterest = 0
            }

            combinedItems = combinedItems.sort(
                (a, b) => a.datePayment.getTime() - b.datePayment.getTime()
            ) // sort only once

            // calculate "Остаток основного долга на начало периода"
            if (index === 0) {
                item.leftPrincipal = 0
            } else {
                const previousItem = combinedItems[index-1]
                const amount = (previousItem.sumPayment ?? 0) - (previousItem.sumPaymentPrincipal ?? 0)
                item.leftPrincipal = previousItem.leftPrincipal + amount  
            }
        })

        combinedItems = combinedItems.sort(
            (a, b) => a.datePayment.getTime() - b.datePayment.getTime()
        )

        this.totalSum = this.calculateTotalSum(combinedItems)
        this.totalPrincipalSum = this.calculateTotalPrincipal(combinedItems)

        this.progress = 100
        return combinedItems
    }

    private async setUpPreviousAgreementSchedule() {
        this.previousTableFields = this.tableFields.map(field => {
            const coloredField = {...field}
            coloredField.variant = 'primary'
            return coloredField
        })

        const currentAgreementIndex = this.allAgreements!.findIndex(it => this.agreement!.id === it.id)
        const previousAgreement: Agreement | null = this.allAgreements![currentAgreementIndex-1] ?? null
        if (previousAgreement) {
            this.previousAgreement = cloneDeep(previousAgreement)
        }
    }

    public calculateTotalSum(scheduleItems: PlanRow[]) {
        let sum = 0
        scheduleItems.forEach((item) => {
            const parsedSum = Number(item.sumPayment ?? 0)
            if (parsedSum) {
                sum += parsedSum
            }
        })
        return sum
    }

    public calculateTotalPrincipal(scheduleItems: PlanRow[]) {
        let sum = 0
        scheduleItems.forEach((item) => {
            const parsedSum = Number(item.sumPaymentPrincipal ?? 0)
            if (parsedSum) {
                sum += parsedSum
            }
        });
        return sum
    }

    public calculateTotalInterest(scheduleItems: PlanRow[]) {
        let sum = 0
        scheduleItems.forEach((it) => {
            const parsedSum = Number(it.sumPaymentInterest ?? 0)
            if (parsedSum) {
                sum += parsedSum
            }
        })
        return sum
    }

    private async fetchPaymentSchedule(agreementId: number): Promise<PlanSchedule[]> {
        const response = await fetch(`api/budget-loan-schedule/payment-schedule/${agreementId}`)
        if (!response.ok) {
            this.makeToast("Не удалось подтянуть график", "Ошибка", "danger")
            throw new Error('')
        }

        const plans: PlanSchedule[] = await response.json()
        return plans
    }

    private makeToast(message: string, title: string, variant: 'success' | 'danger') {
        this.$bvToast.toast(message, {
            title: title,
            variant: variant,
            solid: true,
        })
    }

    public millisToYear(millis: number | string | null | undefined): string {
        if (!millis) {
            return ''
        }

        const date = new Date(millis)
        const year = date.getFullYear()

        return year.toString()
    }

    public millisToDate(millis: number | string | null | undefined): string {
        if (!millis) {
            return ''
        }

        const formatted = moment(millis).format('DD-MM-YYYY')
        return formatted
    }

    public openAdditionalsModal(action: string | null = null) {
        this.$emit('openAdditionalsModal', action)
    }

    private toYYYYMMDD(date: Date | string | number | null | undefined): string {
        if (!date) {
            return ''
        }

        const formattedDate = moment(date).format('YYYY-MM-DD')
        return formattedDate
    }

    public async handleGenerateSchedule() {
        this.progress = 10
        if (this.checkForm()) {
            await this.generateAndLoadScheduleData(
                this.agreementId,
                this.firstInflowDate!,
                this.firstPrincipalDate!,
                this.firstInterestDate!,
                this.otherDatesDay!,
                this.otherDatesMonth!,
                this.frequency!.value,
                this.frequencyIncome!.value,
                this.frequencyRate!.value
            )
        }
        this.progress = 100
        this.$emit('reloadFact')
    }

    private checkForm() {
        let validated = true

        if (!this.firstInflowDate) {
            this.makeToast(
                "Укажите дату первого поступления",
                "Сообщение",
                "danger"
            )
            validated = false
        }
        if (!this.firstPrincipalDate) {
            this.makeToast(
                "Укажите дату первого погашения",
                "Сообщение",
                "danger"
            )
            validated = false
        }
        if (!this.frequencyIncome) {
            this.makeToast(
                "Укажите периодичность поступления",
                "Сообщение",
                "danger"
            )
            validated = false
        }
        if (!this.frequency) {
            this.makeToast(
                "Укажите периодичность погашения основного долга",
                "Сообщение",
                "danger"
            )
            validated = false
        }
        if (!this.frequencyRate) {
            this.makeToast(
                "Укажите периодичность погашения вознаграждения",
                "Сообщение",
                "danger"
            )
            validated = false
        }
        if (!this.firstInterestDate) {
            this.makeToast(
                "Укажите начальную дату погашения вознаграждения",
                "Сообщение",
                "danger"
            )
            validated = false 
        }
        if (this.otherDatesMonth || this.otherDatesDay) {
            if ((this.otherDatesMonth??-1) < 0 || (this.otherDatesMonth??-1) > 12) {
                this.makeToast(
                    "Последующая дата погашения вознаграждения: месяц должен быть между 1 и 12",
                    "Сообщение",
                    "danger"
                )
                validated = false 
            } else if ((this.otherDatesDay??-1) < 0 || (this.otherDatesDay??-1) > 28) {
                this.makeToast(
                    "Последующая дата погашения вознаграждения: день должен быть между 1 и 28",
                    "Сообщение",
                    "danger"
                )
                validated = false 
            }
        }

        const mainStartTime = moment(this.mainAgreementForm.signDate).startOf('day').valueOf()
        const endTime = moment(this.agreement!.returnDate).startOf('day').valueOf()
        if (this.firstInflowDate) {
            const inflowTime = moment(this.firstInflowDate).startOf('day').valueOf()
            if (inflowTime < mainStartTime) {
                this.makeToast(
                    "Дата поступления не может быть раньше даты подписания договора",
                    "Сообщение",
                    "danger"
                )
                validated = false
            } else if (inflowTime > endTime) {
                this.makeToast(
                    "Дата поступления не может быть позже даты возврата",
                    "Сообщение",
                    "danger"
                )
                validated = false
            }
        }
        if (this.firstPrincipalDate) {
            const prinicpalTime = moment(this.firstPrincipalDate).startOf('day').valueOf()
            if (prinicpalTime < mainStartTime) {
                this.makeToast(
                    "Дата погашения не может быть раньше даты подписания договора",
                    "Сообщение",
                    "danger"
                )
                validated = false
            } else if (prinicpalTime > endTime) {
                this.makeToast(
                    "Дата погашения не может быть позже даты возврата",
                    "Сообщение",
                    "danger"
                )
                validated = false
            }
        }
        if (this.firstInterestDate) {
            const interestTime = moment(this.firstInterestDate).startOf('day').valueOf()
            if (interestTime < mainStartTime) {
                this.makeToast(
                    "Дата погашения вознаграждения не может быть раньше даты подписания договора",
                    "Сообщение",
                    "danger"
                )
                validated = false
            } else if (interestTime > endTime) {
                this.makeToast(
                    "Дата погашения вознаграждения не может быть позже даты возврата",
                    "Сообщение",
                    "danger"
                )
                validated = false
            }
        }

        return validated
    }

    private async generateAndLoadScheduleData(
        agreementId: number,
        firstInflowDate: Date,
        firstPrincipalDate: Date,
        firstInterestDate: Date,
        otherDatesDay: number,
        otherDatesMonth: number,
        frequency: string,
        frequencyIncome: string,
        frequencyRate: string
    ) {
        // 1. Сгенерировать поступления
        const inflowResponse = await this.fetchPaymentInflowSchedule(
            agreementId,
            firstInflowDate,
            frequencyIncome
        )
        if (!inflowResponse.ok) {
            this.makeToast(
                "Не удалось подтянуть график",
                "Ошибка",
                "danger"
            );
            this.progress = 100
            return
        }
        this.progress = 30

        // 2. Сгенерировать погашения
        const principalResponse = await this.fetchPrincipalRepaymentSchedule(
            agreementId,
            firstPrincipalDate,
            frequency
        );
        if (!principalResponse.ok) {
            this.makeToast(
                "Не удалось подтянуть график",
                "Ошибка",
                "danger"
            );
            this.progress = 100
            return
        }
        this.progress = 60
        
        // 3. Сгенерировать вознаграждения (при ставке != 0)
        let interestItems = []
        if (this.agreement?.rate !== 0) {
            const interestUpdateResponse = await this.updateInterestDateInAgreement(agreementId, firstInterestDate, otherDatesMonth, otherDatesDay)
            if (!interestUpdateResponse.ok) {
                this.makeToast(
                    "Не удалось подтянуть график",
                    "Ошибка",
                    "danger"
                )
                this.progress = 100
                return
            }
            const interestResponse = await this.fetchInterestPaymentSchedule(
                    agreementId,
                    frequencyRate
                )
            if (!principalResponse.ok) {
                this.makeToast(
                    "Не удалось подтянуть график",
                    "Ошибка",
                    "danger"
                );
                this.progress = 100
                return
            }
            interestItems = await interestResponse.json()
            interestItems.map((it: any) => {
                it.sumPaymentInterest = it.sumPayment
                it.sumPayment = undefined
            })
        } else {
            // Удалить вознаграждения при 0-ом проценте
            const interestType = 3
            await fetch(`api/budget-loan-schedule/payment-schedule/type/${agreementId}?typeSchedule=${interestType}`, { method: 'DELETE' })
        }
        
        this.progress = 80
        this.scheduleData = await this.loadScheduleData(agreementId)
        this.emitSetPlan()
        this.progress = 100
        this.makeToast(
            "Сгенерирован новый график",
            "Сообщение",
            "success"
        )
        this.$emit('reloadFact')
    }

    public async handleImportPreviousSchedule() {
        if (!this.previousAgreement) {
            return
        }

        this.progress = 10
        const agreementId: number = this.agreement!.id!
        const response = await fetch(
            `api/budget-loan-schedule/import-previous-plan-schedule/${agreementId}`,
            { method: 'PUT' }
        )

        if (!response.ok) {
            this.makeToast(
                "Не удалось импортировать данные",
                "Сообщение",
                "danger"
            )
            this.progress = 100
            return
        }

        this.progress = 50

        this.scheduleData = await this.loadScheduleData(agreementId)
        this.setInterestDateIfPresent(this.previousAgreement)
        this.setFrequenciesIfPresent(this.previousAgreement)
        this.setDatesIfPresent()
        this.emitSetPlan()

        this.progress = 100
        this.makeToast("Импорт выполнен", "Сообщение", "success")
    }

    private async fetchPaymentInflowSchedule(agreementId: number, firstInflowDate: Date, frequencyCode: string) {
        const firstInflowStrDate: string = this.toYYYYMMDD(firstInflowDate)
        const url = "api/budget-loan-schedule/payment-schedule-inflow/generate"
        const queries = `/${agreementId}?start_inflow=${firstInflowStrDate}&frequency=${frequencyCode}`
        const response = await fetch(url + queries)
        return response
    }

    private async fetchPrincipalRepaymentSchedule(agreementId: number, firstInflowDate: Date, frequencyCode: string) {
        const firstInflowDateStr = this.toYYYYMMDD(firstInflowDate)
        const url = 'api/budget-loan-schedule/payment-schedule-principal-repayment/generate'
        const queries = `/${agreementId}?start_repayment=${firstInflowDateStr}&frequency=${frequencyCode}`
        const response = await fetch(url + queries)
        return response
    }

    private async fetchInterestPaymentSchedule(agreementId: number, frequencyCode: string) {
        const url = 'api/budget-loan-schedule/payment-schedule-interest/generate'
        const queries = `/${agreementId}?frequency=${frequencyCode}`
        const response = await fetch(url + queries)
        return response
    }

    private async updateInterestDateInAgreement(agreementId: number, firstInterestDate: Date, otherDatesMonth: number, otherDatesDay: number) {
        let otherDatesMonthParam = otherDatesMonth
        let otherDatesDayParam = otherDatesDay
        if (!otherDatesDay || !otherDatesMonth) {
            otherDatesMonthParam = firstInterestDate.getMonth() + 1
            otherDatesDayParam = firstInterestDate.getDate()
        }
        const firstInterestDateStr = this.toYYYYMMDD(firstInterestDate)

        const url = 'api/budget-loan/update-interest'
        const queries = `/${agreementId}?initial-interest-date=${firstInterestDateStr}&following-interest-month=${otherDatesMonthParam}&following-interest-day=${otherDatesDayParam}`
        return await fetch(url + queries, { method: 'PUT' })
    }

    public handleEditMode(isEnabled: boolean | null = null) {
        this.editInterest = false
        if (isEnabled === null) {
            this.editMode = !this.editMode
        } else {
            this.editMode = isEnabled
        }
        this.stashOrPopOriginalData()
    }

    stashOrPopOriginalData() {
        if (this.editMode) {
            this.tempScheduleData = cloneDeep(this.scheduleData)
            this.tempFrequency = cloneDeep(this.frequency)
            this.tempFrequencyRate = cloneDeep(this.frequencyRate)
            this.tempFrequencyIncome = cloneDeep(this.frequencyIncome)
            this.tempFirstInflowDate = cloneDeep(this.firstInflowDate)
            this.tempFrequencyRate = cloneDeep(this.frequencyRate)
            this.tempFirstPrincipalDate = this.firstPrincipalDate
            this.tempFirstInterestDate = this.firstInterestDate
            this.tempOtherDatesMonth = this.otherDatesMonth
            this.tempOtherDatesDay = this.otherDatesDay
        } else {
            this.scheduleData = this.tempScheduleData
            this.frequency = this.tempFrequency
            this.frequencyRate = this.tempFrequencyRate
            this.frequencyIncome = this.tempFrequencyIncome
            this.firstInflowDate = this.tempFirstInflowDate
            this.frequencyRate = this.tempFrequencyRate
            this.firstPrincipalDate = this.tempFirstPrincipalDate 
            this.firstInterestDate = this.tempFirstInterestDate 
            this.otherDatesMonth = this.tempOtherDatesMonth
            this.otherDatesDay = this.tempOtherDatesDay
        }
    }

    private onEditInterestCheck() {
        this.scheduleData = cloneDeep(this.tempScheduleData)
        this.frequency = cloneDeep(this.tempFrequency)
        this.frequencyRate = cloneDeep(this.tempFrequencyRate)
        this.frequencyIncome = cloneDeep(this.tempFrequencyIncome)
        this.firstInflowDate = cloneDeep(this.tempFirstInflowDate)
        this.frequencyRate = cloneDeep(this.tempFrequencyRate)
        this.firstPrincipalDate = cloneDeep(this.tempFirstPrincipalDate) 
        this.firstInterestDate = cloneDeep(this.tempFirstInterestDate) 
        this.otherDatesMonth = cloneDeep(this.tempOtherDatesMonth)
        this.otherDatesDay = cloneDeep(this.tempOtherDatesDay)
    }

    public async handleSaveEdited() {
        if (this.editInterest) {
            const payload = this.scheduleData
                .filter(it => {
                    // @ts-ignore
                    return (it.dayCount != null && it.dayCount !== '') || it.dateBeg != null
                })
                .map(it => {
                    return {
                        date: this.toYYYYMMDD(it.datePayment),
                        daysCount: Number(it.dayCount ?? 0),
                    }
                })
            const response = await fetch(`api/budget-loan-schedule/edit-day-count/${this.agreementId}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            if (response.ok) {
                this.editInterest = false
                this.editMode = false
                this.makeToast("Редактирование применено", "Сообщение", "success")
                this.progress = 50
                this.scheduleData = await this.loadScheduleData(this.agreementId)
                this.emitSetPlan()

                this.progress = 100
            } else {
                this.makeToast("Редактирование не применено", "Ошибка", "danger")
            }
            return
        }
        this.progress = 10

        this.checkSums()

        this.scheduleData = this.scheduleData.sort(
            (a, b) => a.datePayment.getTime() - b.datePayment.getTime()
        )

        this.editMode = false;

        const allData = cloneDeep(this.scheduleData)
        const inflowData: {
            idContract: number,
            datePayment: string,
            sumPayment: number,
            typeSchedule: number
        }[] = []
        const principalData: {
            idContract: number,
            datePayment: string,
            sumPayment: number,
            typeSchedule: number
        }[] = []
        allData.forEach(item => {
            if (item.sumPayment && Number(item.sumPayment) !== 0) {
                inflowData.push({
                    idContract: this.agreementId,
                    datePayment: this.toYYYYMMDD(item.datePayment),
                    sumPayment: item.sumPayment,
                    typeSchedule: 1
                })
            }
            if (item.sumPaymentPrincipal && Number(item.sumPaymentPrincipal) !== 0) {
                principalData.push({
                    idContract: this.agreementId,
                    datePayment: this.toYYYYMMDD(item.datePayment),
                    sumPayment: item.sumPaymentPrincipal,
                    typeSchedule: 2
                })
            }
        })
        this.progress = 20

        // Сохранить метаданные по графику
        try {
            const response = await this.updateScheduleMetaData(
                this.agreementId,
                this.frequency!.value,
                this.frequencyIncome!.value,
                this.frequencyRate!.value,
                this.firstInterestDate!,
                this.otherDatesMonth!,
                this.otherDatesDay!
            )
            if (!response.ok) {
                this.makeToast("Ошибка редактирование", "Сообщение", "danger")
                this.progress = 100
                return
            }
        } catch (error) {}

        // Сохранить поступления
        await fetch(`api/budget-loan-schedule/payment-schedule/${this.agreementId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(inflowData)
        })
        this.progress = 40
        // Сохранить погашения
        await fetch(`api/budget-loan-schedule/payment-schedule/${this.agreementId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(principalData)
        })
        this.progress = 60

        // Сгенерировать вознаграждения (при ставке != 0)
        if (this.agreement?.rate !== 0) {
            await this.fetchInterestPaymentSchedule(
                this.agreementId,
                this.frequencyRate!.value,
            )
        } else {
            // Удалить вознаграждения при 0-ом проценте
            const interestType = 3
            await fetch(`api/budget-loan-schedule/payment-schedule/type/${this.agreementId}?typeSchedule=${interestType}`, { method: 'DELETE' })
        }
        
        this.progress = 80
        this.scheduleData = await this.loadScheduleData(this.agreementId)
        this.emitSetPlan()
        this.progress = 100
        this.makeToast("Редактирование применено", "Сообщение", "success")
        this.$emit('reloadFact')
    }

    private async updateScheduleMetaData(
        id: number,
        frequency: string,
        frequencyIncome: string,
        frequencyRate: string,
        initialInterestDate: Date,
        followingInterestMonth: number,
        followingInterestDay: number,
    ) {
        const params: Record<string, any> = {}
        params['frequency'] = frequency
        params['frequency-income'] = frequencyIncome
        params['frequency-rate'] = frequencyRate
        params['initial-interest-date'] = this.toYYYYMMDD(initialInterestDate)
        params['following-interest-month'] = followingInterestMonth
        params['following-interest-day'] = followingInterestDay
        const requestParams = new URLSearchParams(params)
        return await fetch(
            `api/budget-loan/update-schedule-meta-data/${id}?${requestParams}`,
            { method: 'PUT' }
        ) 
    }

    private checkSums() {
        const newSum = this.calculateTotalSum(this.scheduleData)
        const newPrincipalSum = this.calculateTotalPrincipal(this.scheduleData)

        if (this.agreement!.amount !== newSum) {
            this.makeToast(
                "Сумма платежей не совпадает суммой договора",
                "Сообщение",
                "danger"
            )
        }
        
        if (this.agreement!.amount !== newPrincipalSum) {
            this.makeToast(
                "Сумма платежей не совпадает суммой договора",
                "Сообщение",
                "danger"
            )
        }
    }

    public onFieldChange(fieldName: keyof PlanRow, value: any, index: number) {
        if (fieldName === 'datePayment' || fieldName === 'dateBeg' || fieldName === 'dateEnd') {
            this.scheduleData[index][fieldName] = value
        } else {
            //@ts-ignore
            this.scheduleData[index][fieldName] = value
        }
    }

    public handleAddRow(id: number, toAbove: boolean) {
        const scheduleRows = cloneDeep(this.scheduleData)
        for (let i = 0; i < scheduleRows.length; i++) {
            const row = scheduleRows[i]
            if (row.id === id) {
                const newMaxId: number = scheduleRows.map(it => it.id!).sort((a, b) => b - a)[0] ?? 1
                let position = i
                if (!toAbove) {
                    position += 1
                }
                scheduleRows.splice(position, 0, {
                    id: newMaxId,
                    idContract: this.agreementId,
                    datePayment: new Date(),
                    sumPayment: 0,
                    sumPaymentPrincipal: null,
                    sumPaymentInterest: null,
                    leftPrincipal: 0,
                    dateBeg: null,
                    dateEnd: null,
                    dayCount: null,
                    sumBase: null,
                    typeSchedule: 1,
                    userName: null,
                    updateDate: null,
                })
                break
            }
        }
        this.scheduleData = scheduleRows
    }

    public handleRemoveRow(id: number) {
        this.scheduleData = this.scheduleData.filter(item => item.id !== id)
    }

    public goBack() {
        this.$router.push('/budget-loan-table')
    }

    public formatNumber = formatNumber
    // #endregion
}
